export default __webpack_public_path__ + "static/media/szafy2.62d2162f.jpg";